import { Dialog, DialogTitle, Divider, type DialogProps } from '@shared/components';
import { useMemo } from 'react';

import { useQConfigGeneratorCreationForm } from '../../providers';
import {
  AddQBankToQConfigGeneratorForm,
  type AddQBankToQConfigGeneratorFormValues,
} from '../add-qbank-to-qconfig-generator-form';

interface AddQBankToQConfigGeneratorModalProps extends DialogProps {
  onClose: () => void;
}

export default function AddQBankToQConfigGeneratorModal(
  props: Readonly<AddQBankToQConfigGeneratorModalProps>,
) {
  const { onClose, ...restProps } = props;
  const formContext = useQConfigGeneratorCreationForm();
  const handleSetSelectedQBankStructure = (value: AddQBankToQConfigGeneratorFormValues | null) => {
    if (value !== null) {
      formContext.reset({
        ...formContext.getValues(),
        qbank: [...(formContext.watch('qbank') ?? []), value],
      });
    }
  };
  const addedQBSIds = useMemo(
    () =>
      (formContext.watch('qbank')?.map((item) => item.qbankSelection?.value) ?? []).filter(
        (id) => id !== null && id !== undefined,
      ),
    [formContext],
  );

  return (
    <Dialog {...restProps}>
      <DialogTitle onClose={onClose}>Add QBank</DialogTitle>
      <Divider />
      <AddQBankToQConfigGeneratorForm
        setSelectedQBankStructure={handleSetSelectedQBankStructure}
        onClose={onClose}
        addedQBSIds={addedQBSIds}
      />
    </Dialog>
  );
}
